import * as MessagesActionTypes from 'actiontypes/messages';
import MessagesService from 'services/MessagesService';
import { processMessages} from 'actions/app';

const cancelRequested = () => ({ type: MessagesActionTypes.CANCEL_REQUESTED });

const cancelSuccess = (data: any) => ({
  type: MessagesActionTypes.CANCEL_SUCCESS,
  payload: { cancelledId: data },
});

const cancelFailure = (error: any) => ({
  type: MessagesActionTypes.CANCEL_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

const messagesService = new MessagesService();

/** ----------------------------------------------------------------------------
 * CANCEL A REQUEST
 -----------------------------------------------------------------------------*/
export default function cancel(eventId: number) {
  return async (dispatch: Function) => {
    dispatch(cancelRequested());
    try {
      const { data } = await messagesService.cancelInvitation(eventId);
      if (data && data.messages) {
        dispatch(processMessages(data.messages));
      }
      dispatch(cancelSuccess(eventId));
    } catch (error) {
      dispatch(cancelFailure(error));
    }
  };
}